var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { VePie } from "v-charts";
import { HomePageService } from '~/services/domain-service/home-page.service';
var CaseRecordChart = /** @class */ (function (_super) {
    __extends(CaseRecordChart, _super);
    function CaseRecordChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            overduePeriod: 'N0'
        };
        _this.caseRecordChart = {
            data: {
                columns: ['actionName', 'codeNum'],
                rows: _this.initDataRows
            },
            setting: {
                labelMap: {
                    actionName: '行动代码名称',
                    actionCode: '行动代码',
                    codeNum: '代码数量',
                },
                labelLine: {
                    show: false
                },
                label: {
                    position: 'inside',
                    formatter: '{b}: {d}%'
                },
                radius: 130
            },
            legend: {
                icon: 'circle',
                itemWidth: 10,
                itemHeight: 10,
                y: 'bottom',
                x: 'center'
            }
        };
        return _this;
    }
    Object.defineProperty(CaseRecordChart.prototype, "initDataRows", {
        get: function () {
            var followupBack = this.$dict.getDictData('FollowupBack');
            return followupBack.map(function (v) {
                return {
                    actionName: v.name,
                    actionCode: v.code,
                    codeNum: 0
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    CaseRecordChart.prototype.updateData = function () { };
    CaseRecordChart.prototype.mounted = function () {
        this.updateData();
    };
    __decorate([
        Dependencies(HomePageService)
    ], CaseRecordChart.prototype, "homePageService", void 0);
    CaseRecordChart = __decorate([
        Component({
            components: {
                VePie: VePie
            }
        })
    ], CaseRecordChart);
    return CaseRecordChart;
}(Vue));
export default CaseRecordChart;
